<template>
  <div class="invoice">
    <div class="title text-no">
      <div class="flex1">
        <div
          class="tabs"
          :class="tab == 1 ? 'tabBorder' : ''"
          @click="cutover(1)"
        >
          待开发票
        </div>
        <div
          class="tabs"
          :class="tab == 2 ? 'tabBorder' : ''"
          @click="cutover(2)"
        >
          开票历史
        </div>
      </div>
    </div>
    <div class="main">
      <tostart v-if="tab == 1"></tostart>
      <pastRecords v-if="tab == 2"></pastRecords>
    </div>
  </div>
</template>

<script>
import tostart from "./component/tostart.vue";
import pastRecords from "./component/pastRecords.vue";
import { paths } from '../../utils/pathNew.js'
export default {
  data() {
    return {
      tab: window.sessionStorage.getItem("invoice") == null? (window.localStorage.getItem("invoice") == null?1 : window.localStorage.getItem("invoice") ) : window.sessionStorage.getItem("invoice") ,
    };
  },
  components: {
    tostart,
    pastRecords,
  },
  methods: {
    cutover(i) {
      if (i == this.tab) return;
      this.tab = i;
      window.localStorage.setItem("invoice", i);
      window.sessionStorage.setItem("invoice", i);
    },
  },
  created(){
    // Tab 导航栏 样式跟随
    let url = window.location.hash;
    this.$store.commit("urlIndex", paths(url));
  }
};
</script>

<style lang="less">
.invoice {
  font-family: 'Avenir', 'Helvetica', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background-color: #f7f7f8ff;

  .title {
    display: flex;
    justify-content: center;
    height: 46px;
    line-height: 44px;
    box-shadow: 0px 9px 20px 0px rgba(102, 139, 204, 0.04);
    border: 1px solid #ececec;
    background-color: #fff;
    .flex1 {
      display: flex;
      cursor: pointer;
      .tabs {
        width: 64px;
        margin-right: 48px;
        &:hover {
          color: #008cffff;
          border-bottom: 2px solid #008cffff;
          max-width: 64px;
        }
      }
    }
  }
  .main {
    flex: 1;
    overflow: auto;
    margin: 24px 32px;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(0, 1, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
    }
  }
}
.tabBorder {
 // color: #000;
  border-bottom: 2px solid #008cffff;
  color:#008cffff ;
}
</style>